import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { TABLE_DEAL_COMMITMENTS, FIELD_KEY_SEPARATOR, FIELD_KEY_PROG, FIELD_KEY_ACTION } from '../globals.ts'
import { DealCommitmentsModelFields } from './deal_commitments_model.ts'

const ALIAS_DEAL_COMMITMENTS = `${TABLE_DEAL_COMMITMENTS}${FIELD_KEY_SEPARATOR}` as const

const FIELD_DEAL_COMMITMENTS_ID = `${ALIAS_DEAL_COMMITMENTS}${DealCommitmentsModelFields.id}` as const
const FIELD_DEAL_COMMITMENTS_AMOUNT = `${ALIAS_DEAL_COMMITMENTS}${DealCommitmentsModelFields.amount}` as const
const FIELD_DEAL_COMMITMENTS_FUND_ID = `${ALIAS_DEAL_COMMITMENTS}${DealCommitmentsModelFields.fund_id}` as const
const PROG_DEAL_COMMITMENTS_ACTION = `${FIELD_KEY_PROG}${TABLE_DEAL_COMMITMENTS}${FIELD_KEY_ACTION}` as const

export const DealCommitmentEntrySchema = z
  .object({
    [FIELD_DEAL_COMMITMENTS_ID]: z.string(),
    [FIELD_DEAL_COMMITMENTS_AMOUNT]: z.number().nullish(),
    [FIELD_DEAL_COMMITMENTS_FUND_ID]: z.string().nullish(),
    [PROG_DEAL_COMMITMENTS_ACTION]: z.string()
  })
  .strict()

export const DealCommitmentEntryFields = makeFieldKeys(DealCommitmentEntrySchema)

export type DealCommitmentEntry = z.infer<typeof DealCommitmentEntrySchema>

export function validateDealCommitmentEntry(data: unknown): DealCommitmentEntry {
  try {
    return validateWithZodSchema(DealCommitmentEntrySchema, data, 'deal commitment entry')
  } catch (error) {
    throw new Error(`Deal commitment entry validation failed: ${error}`)
  }
}
